<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        title="Opções de impressão"
    >
        <rkm-form
            v-if="data.model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-if="data.form.impressoes && data.form.impressoes.length > 1"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="checkUncheckAll"
                        v-model="checkedAll"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group v-model="data.model.impressoes" stacked>
                        <rkm-form-checkbox
                            v-for="permissao in data.form.impressoes"
                            :key="permissao.value"
                            :value="permissao.value"
                            :disabled="permissao.disabled"
                            class="mb-0"

                        >
                            {{ permissao.text }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="(data.model && data.model.impressoes ? data.model.impressoes.length === 0 : true) || !!loading"
                @click="print"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

// Utils.
import etiqueta from '@/utils/cadastro/impressao/etiqueta'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

// Moment.
import moment from 'moment'

export default {
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            loading: 'getLoading',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        atendimentoId: null,
        checkedAll: false,
        indeterminate: false,
        origem: null,
        utils: { etiqueta },
        enums: {sexo},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.$refs.RkmModal.show()
        },
        checkUncheckAll(value) {
            this.data.model.impressoes = value
                ? this.data.form.impressoes.filter(item => !item.disabled).map(impressao => impressao.value)
                : []
        },
        print() {

            const repositoryItems = {
                termoRecusaCadastro: () =>this.repositories.impressao.termoRecusaCadastro(this.data.model.id),
                cadastroIndividual: () =>this.repositories.impressao.ficha(this.data.model.id),
                cadastroDomiciliar: () =>this.repositories.impressao.fichaCadastroDomiciliar(this.data.form.cadastroDomiciliarId),
                residentes: () =>this.repositories.impressao.fichaResidentes(this.data.form.domicilioId),
            }

            this.data.model.impressoes.forEach(impressao => {

                if (impressao in repositoryItems) {

                    this.setLoading()

                    repositoryItems[impressao]()
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }

                if (impressao == 'etiquetaConectasus') {

                    this.utils.etiqueta.print({
                        ...this.data,
                        unidadeLogada: this.lotacao.infraestrutura.nome,
                        sexo: this.data.model.cidadao.sexoId === this.enums.sexo.FEMININO ? 'F' : 'M',
                        dataNascimento: moment(this.data.model.cidadao.dataNascimento).format('DD/MM/YYYY'),
                    })
                }
            })
        },
        close() {
            this.$refs.RkmModal.hide()
            this.$emit('closed')
        },
    },
    mixins: [error, file, repository, stringCase],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'model.impressoes'(value) {
            this.checkedAll = value.length > 0 && value.length == this.data.form.impressoes.length
            this.indeterminate = value.length > 0 && value.length != this.data.form.impressoes.length
        },
    },
}
</script>